export default "__VITE_ASSET__CJ87OFDN__"